import colors from 'theme/colors';

export const COLORS_MAP = {
  action: '#1BBB97',
  reaction: '#1DAF61',
  target: '#A96CDF',
  task: '#A96CDF',
  tracker: '#1995DB',
};

export const RESOURCE_TYPES = {
  ACTION: 'action' as 'action',
  REACTION: 'reaction' as 'reaction',
  TARGET: 'target' as 'target',
  TRACKER: 'tracker' as 'tracker',
};

export const TARGET_ATTRIBUTES_NAMES = {
  NAME: 'name',
  PRIORITY: 'priority',
  FULFILLS_INTENT: 'fulfills_intent',
  REFERENTS: 'referents',
  TASK_RESET: 'task_reset',
  DEFAULT: 'default',
};

export const TRACKER_ATTRIBUTES_NAMES = {
  NAME: 'name',
  EVENTS_TRIGGER: 'events_trigger',
};

export const REACTION_ATTRIBUTES_NAMES = {
  NAME: 'name',
  EVENT: 'event',
};

export const REACTION_EVENT_TYPES = {
  DIALOG_WELCOME_EVENT: 'DIALOG_WELCOME_EVENT',
  DIALOG_NO_MATCH_EVENT: 'DIALOG_NO_MATCH_EVENT',
  DIALOG_NO_INPUT_EVENT: 'DIALOG_NO_INPUT_EVENT',
  DIALOG_SAME_STATE_EVENT: 'DIALOG_SAME_STATE_EVENT',
  DIALOG_CRITICAL_ERROR_EVENT: 'DIALOG_CRITICAL_ERROR_EVENT',
  DIALOG_NICE_USER_RESPONSE_EVENT: 'DIALOG_NICE_USER_RESPONSE_EVENT',
  DIALOG_CUSTOM_EVENT: 'DIALOG_CUSTOM_EVENT',
};

export const TRACKER_ATTRIBUTES_VALUES = {
  EVENTS_TRIGGER: { ANY: 'any', ALL: 'all' },
};

export const ATTRIBUTES_TASK_RESET_VALUES = {
  ON_REFERENT: 'onReferent' as 'onReferent',
  ON_INTENT: 'onIntent' as 'onIntent',
  NEVER: 'never' as 'never',
};

export const TARGET_ON_COMPLETE_ACTION_TYPES = {
  EXIT_ACTION: 'exit_action',
  TRANSFER_ACTION: 'transfer_action',
  REQUEST_INTENT: 'request_intent',
};

export const TASK_TYPES = {
  REQUEST: 'Request',
  ANNOUNCE_MESSAGE: 'AnnounceMessage',
  ANNOUNCE: 'Announce',
  CONFIRM: 'Confirm',
};

export const TASK_TYPES_MAP = {
  [TASK_TYPES.REQUEST]: 'Request',
  [TASK_TYPES.ANNOUNCE_MESSAGE]: 'Announce Message',
  [TASK_TYPES.ANNOUNCE]: 'Announce Field',
  [TASK_TYPES.CONFIRM]: 'Confirm',
};

export const TASK_RESET_TYPES = {
  INTENT_OR_REFERENT: 'INTENT_OR_REFERENT',
  INTENT: 'INTENT',
  REFERENT: 'REFERENT',
  NEVER: 'NEVER',
};

export const LOG_SUPPRESSION_TYPES = {
  NONE: 'NONE',
  CUSTOM: 'CUSTOM',
  CC_CUSTOM: 'CC_CUSTOM',
  FULL_ENVELOPE_ENCRYPTION: 'FULL_ENVELOPE_ENCRYPTION',
  CC_ENVELOPE_ENCRYPTION: 'CC_ENVELOPE_ENCRYPTION',
  FULL: 'FULL',
};

export const INIT_FROM_PARAM_TYPES = {
  NONE: 'NONE',
  ANI: 'ANI',
  DNIS: 'DNIS',
};

export const UNIT_TYPE_TYPES = {
  DATE: 'DATE',
  HOUR: 'HOUR',
  YEAR: 'YEAR',
  DAY_OF_WEEK: 'DAY_OF_WEEK',
  DAY_OF_MONTH: 'DAY_OF_MONTH',
  MONTH: 'MONTH',
};

export const AUTO_RESOLUTION_TYPES = {
  ON: 'ON',
  OFF: 'OFF',
};

export const AUTO_UPDATE_TYPES = {
  ON: 'ON',
  OFF: 'OFF',
  ON_INTENT: 'ON_INTENT',
  ON_TARGET: 'ON_TARGET',
  ON_ACTIVE: 'ON_ACTIVE',
};

export const RESOLUTION_DIRECTION_TYPES = {
  FORWARD: 'FORWARD',
  BACKWARD: 'BACKWARD',
};

export const SHIFT_INVALID_TYPES = {
  TRUE: true,
  FALSE: false,
};

export const FIELD_TYPE_TYPES = {
  GENERAL: 'GENERAL',
  MONETARY: 'MONETARY',
  TEMPORAL: 'TEMPORAL',
};

// ------ ACTIONS ---------
export const ACTION_NAMES = {
  ASK: 'Ask' as 'Ask',
  ANNOUNCEMENT: 'Announcement' as 'Announcement',
  DISAMBIGUATION: 'Disambiguation' as 'Disambiguation',
  BACKENDCALL: 'BackEndCall' as 'BackEndCall',
  CONFIRMATION: 'Confirmation' as 'Confirmation',

  // rest action types (for future implementation)
  // SUGGESTION: 'Suggestion',
};

export const ANNOUNCEMENT_TYPE = {
  FIELD: 'FIELD' as 'FIELD',
  MESSAGE: 'MESSAGE' as 'MESSAGE',
};

export const ACTION_ATTRIBUTES_NAMES = {
  NAME: 'name' as 'name',
  ALLOW_NICE_RESPONSE_REACTION: 'allow_nice_response_reaction' as 'allow_nice_response_reaction',
  BARGE_IN: 'barge_in' as 'barge_in',
  TAG: 'tag' as 'tag',
  ORDER: 'order' as 'order',
  FIELDS: 'fields' as 'fields',
  LOG_EVENT: 'log_event' as 'log_event',
  MESSAGE: 'message' as 'message',
};

export const BACKENDCALL_CUSTOM_MODULE_CALL_FIELDS = {
  INITIAL_WAIT_TIME: 'initial_wait_time',
  ADDITIONAL_WAIT_TIME: 'additional_wait_time',
  MAX_WAIT_TIME: 'max_wait_time',
  FUNCTION: 'function',
  INPUT_FIELDS: 'input_fields',
  OUTPUT_FIELDS: 'output_fields',
};

export const BACKENDCALL_DEFAULT_TIMES = {
  [BACKENDCALL_CUSTOM_MODULE_CALL_FIELDS.MAX_WAIT_TIME]: '9000',
  [BACKENDCALL_CUSTOM_MODULE_CALL_FIELDS.INITIAL_WAIT_TIME]: null,
  [BACKENDCALL_CUSTOM_MODULE_CALL_FIELDS.ADDITIONAL_WAIT_TIME]: null,
};

export const PROMPTS_LEVELS = {
  NORMAL: 'normal',
  ERROR: 'error',
  INITIAL_WAIT: 'initialWait',
  ADDITIONAL_WAIT: 'additionalWait',
};

export const RESOURCE_LABELS = {
  [RESOURCE_TYPES.TARGET]: 'Target',
  [RESOURCE_TYPES.ACTION]: {
    [ACTION_NAMES.ASK]: 'Ask',
    [ACTION_NAMES.ANNOUNCEMENT]: 'Announcement',
    [ACTION_NAMES.DISAMBIGUATION]: 'Disambig',
    [ACTION_NAMES.BACKENDCALL]: 'BackEnd',
    [ACTION_NAMES.CONFIRMATION]: 'Confirmation',
  },
  [RESOURCE_TYPES.TRACKER]: 'Tracker',
  [RESOURCE_TYPES.REACTION]: 'Reaction',
};

export const RESOURCE_NAMES = {
  [RESOURCE_TYPES.TARGET]: 'Target',
  [RESOURCE_TYPES.ACTION]: {
    [ACTION_NAMES.ASK]: 'Ask',
    [ACTION_NAMES.ANNOUNCEMENT]: 'Announcement',
    [ACTION_NAMES.DISAMBIGUATION]: 'Disambiguation',
    [ACTION_NAMES.BACKENDCALL]: 'BackEnd Call',
    [ACTION_NAMES.CONFIRMATION]: 'Confirmation',
  },
  [RESOURCE_TYPES.TRACKER]: 'Tracker',
  [RESOURCE_TYPES.REACTION]: 'Reaction',
};

export const CANVAS_ZOOM = {
  FIT_LEVEL: 1,
  DEFAULT_LEVEL: 0.9,
  LEVEL_FACTOR: 0.1,
};

export const ADD_FIELDS_SOURCES = {
  DRAWER: 'drawer',
  FIELDS: 'fields',
  RESOURCE_MODAL: 'resource-modal',
};

export const FIELD_CATEGORY = {
  ENTITY: 'ENTITY' as 'ENTITY',
  BUILT_IN: 'BUILT_IN' as 'BUILT_IN',
  FLOW: 'FLOW' as 'FLOW',
  MESSAGE: 'MESSAGE' as 'MESSAGE',
};

export const FIELD_TYPES = {
  REFERENTS: 'REFERENTS' as 'REFERENTS',
  TASK_RESET: 'TASK_RESET' as 'TASK_RESET',
};

export const REALIZER_TYPES = {
  CUSTOM: 'CUSTOM_REALIZER' as 'CUSTOM_REALIZER',
  TEXT: 'TEXT_REALIZER' as 'TEXT_REALIZER',
};

export const GRAMMAR_TYPES = {
  NLU: 'NLU_GRAMMAR' as 'NLU_GRAMMAR',
  DTMF: 'DTMF_GRAMMAR' as 'DTMF_GRAMMAR',
};

export const FIELD_CATEGORY_COLOR = {
  [FIELD_CATEGORY.ENTITY]: colors.alohaGreen,
  [FIELD_CATEGORY.BUILT_IN]: colors.lavenderPurple,
  [FIELD_CATEGORY.FLOW]: colors.dixieBrown,
  [FIELD_CATEGORY.MESSAGE]: colors.ribbonBlue,
  [REALIZER_TYPES.CUSTOM]: colors.ribbonBlue,
  [REALIZER_TYPES.TEXT]: colors.ribbonBlue,
  [GRAMMAR_TYPES.NLU]: colors.ribbonBlue,
  [GRAMMAR_TYPES.DTMF]: colors.ribbonBlue,
};

export const UTTERANCE_TYPES = {
  NORMAL: 'normal' as 'normal',
  FIELD_VALUE: 'field_value' as 'field_value',
};

export const PROMPT_TYPES = {
  NORMAL_PROMPT: 'normal_prompt' as 'normal_prompt',
  ERROR_PROMPT: 'error_prompt' as 'error_prompt',
};

export const INTENT = 'Intent' as 'Intent';

export const EFFECT_TYPES = {
  FIELD_VALUE_CHANGE_TO: 'FIELD_VALUE_CHANGE_TO' as 'FIELD_VALUE_CHANGE_TO',
  FIELD_STATUS_CHANGE_TO: 'FIELD_STATUS_CHANGE_TO' as 'FIELD_STATUS_CHANGE_TO',
  LOG_EVENT: 'LOG_EVENT' as 'LOG_EVENT',
  FIELD_VALUE_INCREMENT: 'FIELD_VALUE_INCREMENT' as 'FIELD_VALUE_INCREMENT',
  FIELD_DROP_VALUE: 'FIELD_DROP_VALUE' as 'FIELD_DROP_VALUE',
  FIELD_RESET_VALUE: 'FIELD_RESET_VALUE' as 'FIELD_RESET_VALUE',
  FIELD_RESTORE_VALUE: 'FIELD_RESTORE_VALUE' as 'FIELD_RESTORE_VALUE',
  THROW_DIALOG_EVENT: 'THROW_DIALOG_EVENT' as 'THROW_DIALOG_EVENT',
  SINK_DIALOG_EVENT: 'SINK_DIALOG_EVENT' as 'SINK_DIALOG_EVENT',
  FIELD_VALUE_COPY: 'FIELD_VALUE_COPY' as 'FIELD_VALUE_COPY',
  SET_ERROR_STATE: 'SET_ERROR_STATE' as 'SET_ERROR_STATE',
  ADD_INTENT: 'ADD_INTENT' as 'ADD_INTENT',
  REMOVE_INTENT: 'REMOVE_INTENT' as 'REMOVE_INTENT',
  DROP_INTENT: 'DROP_INTENT' as 'DROP_INTENT',
  RESET_TASK_STATUS: 'RESET_TASK_STATUS' as 'RESET_TASK_STATUS',
  REACTION: 'REACTION' as 'REACTION',
};

export const STATUS_VALUES = {
  DEFINED: 'Defined',
  UNDEFINED: 'Undefined',
  AMBIGUOUS: 'Ambiguous',
  IMPLICITLY_CONFIRMED: 'Implicitly-Confirmed',
  EXPLICITLY_CONFIRMED: 'Explicitly-Confirmed',
  REFERENCED: 'Referenced',
  REJECTED: 'Rejected',
  INFERRED: 'Inferred',
  OPTIONED: 'Optioned',
  DROPPED: 'Dropped',
  FULFILLED: 'Fulfilled',
};
